import { Cryptocurrency, Fiat } from './currency'
import { Region } from './region'
import { Topic } from './academy'

export interface File {
  url: string
  name: string
}

export interface Image extends File {
  formats?: {
    thumbnail?: {
      url: string
      name: string
    }
    large?: {
      url: string
      name: string
    }
    medium?: {
      url: string
      name: string
    }
    small?: {
      url: string
      name: string
    }
  }
}

export enum LoadState {
  IDLE,
  LOADING,
  LOADED,
  ERROR,
}

export interface Filters {
  order?: string
  cryptocurrency?: Cryptocurrency
  fiat?: Fiat
  depositCryptocurrency?: Cryptocurrency
  depositInput?: number
  depositPeriod?: '1' | '2' | '3'
  region?: Region
  topic?: string
  _limit?: number
}
